import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { buildListChannelName } from '../../logic/buildListChannelName';
import { ListPrivateWebsocketEvent } from '../../types/ListPrivateWebsocketEvent';
import { ListPrivateWebsocketEventPayload } from '../../types/ListPrivateWebsocketEventPayload';

export const useSubscribeToListDocumentQueueAssigned = (
  onUpdate: (
    payload: ListPrivateWebsocketEventPayload[ListPrivateWebsocketEvent.DocumentQueueAssignedEvent],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildListChannelName(),
    ListPrivateWebsocketEvent.DocumentQueueAssignedEvent,
    onUpdate,
  );
};
